import { userDefaults } from 'utils/mocks/user'
import { GoodtrustApiMock } from 'utils/mocks/api.mock'
import { rest } from 'msw'
import { ident } from 'utils/general'
import { ApiType } from 'utils/types'

export class GoodtrustApiMockUserSlice {
  // eslint-disable-next-line no-useless-constructor
  constructor(private api: GoodtrustApiMock) {}
  handlers() {
    return [
      rest.get(this.api.prefixed('/api/v1/user/me'), (req, res, ctx) => {
        return res(
          ctx.status(200),
          ctx.json<ApiType['UserResponse']>({
            ...userDefaults,
            uuid: 'mock-user',
            first_name: 'David',
            last_name: 'Kubac',
          })
        )
      }),
      rest.get(this.api.prefixed('/api/v1/user/tips'), (req, res, ctx) => {
        const extendedTips = ident<ApiType['UserTipResponse']>({
          ...this.api.state.userTips,
          hide_checklist: this.api.state.userTips.hide_checklist ?? false,
          hide_dashboard_onboarding: this.api.state.userTips.hide_dashboard_onboarding ?? false,
          hide_future_message_inspire_banner:
            this.api.state.userTips.hide_future_message_inspire_banner ?? false,
          hide_future_message_onboarding:
            this.api.state.userTips.hide_future_message_onboarding ?? false,
          hide_legacy_contact_banner: this.api.state.userTips.hide_legacy_contact_banner ?? false,
          hide_memory_animation_tip: this.api.state.userTips.hide_memory_animation_tip ?? false,
          hide_memory_banner: this.api.state.userTips.hide_memory_banner ?? false,
          hide_memory_share_tip: this.api.state.userTips.hide_memory_share_tip ?? false,
          partner: this.api.state.userTips.cobranded_partner
            ? this.api.mockCobrandedPartner(this.api.state.userTips.cobranded_partner)
            : undefined,
        })

        return res(ctx.status(200), ctx.json(extendedTips))
      }),
      rest.patch(this.api.prefixed('/api/v1/user/tips'), (req, res, ctx) => {
        const body = req.body as typeof this.api.state.userTips
        this.api.updateState((st) => {
          Object.assign(st.userTips, body)
        })
        return res(ctx.status(200), ctx.json(this.api.state.userTips))
      }),
      rest.get(this.api.prefixed('/api/v1/promocode/claimed'), (req, res, ctx) => {
        return res(ctx.status(200), ctx.json(this.api.state.claimedPromos))
      }),
      rest.post(this.api.prefixed('/api/v1/user/directive/search'), (req, res, ctx) => {
        return res(ctx.status(200), ctx.json([]))
      }),
      rest.get(this.api.prefixed('/api/v2/subscription/list'), (req, res, ctx) => {
        return res(
          ctx.status(200),
          ctx.json(
            ident<ApiType['PublicSubscriptionMapResponse']>({
              subscriptions: {
                ESTATE_PLAN: {
                  DEFAULT: {
                    billing_interval: 'year',
                    currency: 'USD',
                    interval_count: 1,
                    price: 9600,
                    price_id: 'estate-plan-default',
                  },
                },
              },
            })
          )
        )
      }),
    ]
  }
}
